"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allSettledFulfilledPromises = void 0;
function allSettledFulfilledPromises(value) {
    return Promise.allSettled(value).then(function (results) {
        return results
            .map(function (res) { return (res.status === "fulfilled" ? res.value : null); })
            .filter(function (res) { return !!res; });
    });
}
exports.allSettledFulfilledPromises = allSettledFulfilledPromises;
